import React from 'react'
import { createRoot } from 'react-dom/client'
import Gwp from "./Gwp.jsx"

const setupGwp = (gwpWrapper, cart) => {
  if(typeof gwpWrapper != 'undefined' && gwpWrapper && window.gwpData) {
    const root = createRoot(gwpWrapper)
    root.render(<Gwp json={window.gwpData} cart={cart} />)
  }
}

window.setupGwp = setupGwp